import { useCallback } from "react";
import { useBlockCreators } from "@/api/blocklist";
import { useBulkActionContext } from "@/providers/bulk-action-progress-provider";

export const useTrackedBlockCreators = () => {
  const { mutateAsync, isPending } = useBlockCreators();
  const { startTracking } = useBulkActionContext();

  const block = useCallback(
    async (creatorOpenIds: string[]): Promise<number | null> => {
      const result = await mutateAsync(creatorOpenIds);
      if ("async" in result) {
        startTracking(result.jobId, "import_blocklist", null);
        return null;
      }
      return result.blocked;
    },
    [mutateAsync, startTracking],
  );

  return { block, isPending };
};
